import FavoriteStar from './FavoriteStar';
import AchievementFilters from './AchievementFilters';
import PremiumFilterPreview from './PremiumFilterPreview';
import {usePremium,PremiumPanel} from './Premium';
import React, { useState } from 'react';
import { FILTERS, FILTER_IDS } from './FaceFiltersRegistry';
import FilterWorkshop from './FilterWorkshop';
import {FaceSwatch} from './WorkshopFacePicker';
import './BackgroundPicker.css';
import './WorkshopFacePicker.css';

const categories = ["הישגים", "Premium", "הכול", "הפילטרים שלי", "סטודיו", "חיות", "פנטזיה", "צבע ואור", "מופשט", "קלאסיקות"];

export default function FilterPicker({ value, onChange }) {
  const premium=usePremium();
  const [preview,setPreview]=useState(null);
  const [showPremium,setShowPremium]=useState(false);
  const [category, setCategory] = useState("הכול");
  const [query, setQuery] = useState('');
  const [workshop,setWorkshop] = useState(false);
  if(workshop) return <FilterWorkshop onClose={()=>setWorkshop(false)} onSave={id=>{onChange(id);setWorkshop(false);setCategory("הפילטרים שלי");setQuery('');}}/>;
  const visible = FILTER_IDS.filter(id => {
    const filter = FILTERS[id];
    return !filter.reward && (category === "הכול" || filter.category === category) &&
      `${id} ${filter.name} ${filter.description} ${filter.category}`.toLowerCase().includes(query.trim().toLowerCase());
  });
  return <div className="filter-library background-picker workshop-face-picker call-face-picker">
    {preview&&<PremiumFilterPreview initialId={preview} onClose={()=>setPreview(null)} onUpgrade={()=>{setPreview(null);setShowPremium(true);}}/>}
    {showPremium&&<PremiumPanel onClose={()=>setShowPremium(false)}/>}
    <header><div><h3>מוצאים את הלוק שלכם</h3><p>{FILTER_IDS.length} דרכים להראות קצת אופי</p></div>
      <span className="filter-current">{FILTERS[value]?.icon} {FILTERS[value]?.name}</span></header>
    <input className="filter-search workshop-face-search" type="search" aria-label="חיפוש פילטרים לפנים" placeholder="נסו חתול, כתר, צבעוני…" value={query} onChange={e => setQuery(e.target.value)} />
    <button type="button" onClick={()=>setWorkshop(true)}>יצירת פילטר · הסדנה</button>
    <div className="filter-categories" role="group" aria-label="קטגוריות פילטרים">
      {categories.map(item => <button key={item} type="button" aria-pressed={category === item} onClick={() => setCategory(item)}>{item}</button>)}
    </div>
    <div className="workshop-face-results">
      {[false,true].map(paid=>{const group=visible.filter(id=>!!FILTERS[id].premium===paid);return group.length>0&&<section key={String(paid)}><h4>{paid?'Premium · לוקים מיוחדים':'לכולם'}</h4><div className="background-grid">
      {group.map(id=>{const filter=FILTERS[id];return <div className="face-filter-card" key={id}><button type="button" aria-pressed={value===id}
        title={filter.description} onClick={()=>filter.premium&&!premium.active?setPreview(id):onChange(id)}>
        <FaceSwatch id={id}/><strong>{filter.name}</strong>
        {filter.premium&&!premium.active&&<small>🔒 Premium · תצוגה</small>}
      </button><FavoriteStar id={id} name={filter.name} locked={filter.premium&&!premium.active}/></div>;})}
      </div></section>;})}
    </div>
    {(category==='הכול'||category==='הישגים')&&<AchievementFilters value={value} onChange={onChange} query={query} renderPreview={reward=><FaceSwatch reward={reward}/>}/>}
    {category!=='הישגים'&&visible.length === 0 && <p className="filter-empty" role="status">לא נמצאו פילטרים. נסו חיפוש או קטגוריה אחרת.</p>}
    <p className="filter-selection-description" aria-live="polite">{FILTERS[value]?.description}</p>
  </div>;
}
